import { combineReducers } from 'redux';
import runtime from './runtime';
import intl from './intl';
import session from './session';
import user from './user';

export default function createRootReducer({ apolloClient }) {
  return combineReducers({
    // apollo: apolloClient.reducer(),
    user,
    runtime,
    intl,
    session,
  });
}



// WEBPACK FOOTER //
// ./src/reducers/index.js